import { render, staticRenderFns } from "./Admin_Side.vue?vue&type=template&id=670f6bf6&scoped=true"
import script from "./Admin_Side.vue?vue&type=script&lang=js"
export * from "./Admin_Side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f6bf6",
  null
  
)

export default component.exports